"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

export type KbdProps = React.HTMLAttributes<HTMLElement> & {
  children?: React.ReactNode;
};

export const Kbd = React.forwardRef<HTMLElement, KbdProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <kbd
        ref={ref}
        className={cn(
          "pointer-events-none inline-flex min-h-5 items-center justify-center rounded border bg-muted px-1.5 font-mono text-[10px] font-semibold text-muted-foreground",
          className,
        )}
        {...props}
      >
        {children}
      </kbd>
    );
  },
);
Kbd.displayName = "Kbd";

export type KbdGroupProps = React.HTMLAttributes<HTMLSpanElement> & {
  children?: React.ReactNode;
};

export function KbdGroup({ className, children, ...props }: KbdGroupProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-1", className)}
      {...props}
    >
      {children}
    </span>
  );
}

